export const commentBlock = {
    padding: '14px 16px',
    marginBottom: 12,
    borderRadius: 8,
    backgroundColor: '#f9f9fc',
    border: '1px solid #ecedf5',
    transition: 'box-shadow 0.15s ease',
};

export const commentTopRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 8,
};

export const commentAvatar = {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 600,
    color: '#fff',
    flexShrink: 0,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};

export const commentName = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 600,
    fontSize: 13,
    color: '#2b2c35',
    lineHeight: '18px',
};

export const commentTime = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 11,
    color: '#9e9eac',
    lineHeight: '16px',
    marginLeft: 'auto',
};

export const commentActionBadge = {
    display: 'inline-flex',
    alignItems: 'center',
    height: 16,
    borderRadius: 100,
    padding: '0px 6px',
    fontSize: 9,
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 500,
    color: '#fff',
    backgroundColor: '#3f51b5',
    whiteSpace: 'nowrap',
    letterSpacing: 0.2,
    lineHeight: '16px',
};

export const commentText = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '21px',
    color: '#454653',
    paddingLeft: 42,
    wordBreak: 'break-word',
};

export const commentMetaColumn = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};

export const commentNameRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
};

export const commentDateText = {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 11,
    color: '#9e9eac',
    lineHeight: '15px',
};
